import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import React from 'react';
import { BADGE_ICON_SIZE } from './entity-badge.styles';

const StyledBadgeIcon = styled(Icon)`
    width: ${BADGE_ICON_SIZE};
    height: ${BADGE_ICON_SIZE};
    flex-shrink: 0;
    fill: currentColor;
`;

export const BadgeIcon: React.FC<{ path: string }> = ({ path }) => (
    <StyledBadgeIcon path={path} size={BADGE_ICON_SIZE} />
);
